<section class="grid" role="region" aria-labelledby="institution-details-heading">
	<!-- Row 1 - Column 1 -->
	<section class="column" role="region">
		<h3 id="main-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">apartment</mat-icon>
			<span>{{ 'institution.details.institution' | transloco }}</span>
		</h3>

		<section class="info" aria-labelledby="main-heading">
			<p class="name">{{ institution().name }}</p>
			<div class="details">
				<p>
					<span>{{ 'institution.details.employment_required' | transloco }}</span>
					{{
						institution().employmentRequired === undefined
							? ('institution.details.employment_required_null' | transloco)
							: institution().employmentRequired
								? ('institution.details.employment_required_true' | transloco)
								: ('institution.details.employment_required_false' | transloco)
					}}
				</p>

				@if (institution().schoolNumber !== undefined) {
					<p>
						<span>{{ 'institution.details.school_number' | transloco }}</span>
						{{ institution().schoolNumber }}
					</p>
				}
			</div>
		</section>

		<h3 id="address-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">location_on</mat-icon>
			<span>{{ 'institution.details.address' | transloco }}</span>
		</h3>

		<address aria-labelledby="address-heading">
			<p [attr.aria-label]="'base.field.street_address' | transloco">
				{{ institution().address?.streetAndHouseNumber }}
			</p>
			<p [attr.aria-label]="'base.field.postal_code_and_city' | transloco">
				{{ institution().address?.postalCodeAndCity }}
			</p>
		</address>
	</section>
	<!-- Row 1 - Column 2 -->
	<section class="column" role="region">
		<h3 id="communication-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">phone_in_talk</mat-icon>
			<span>{{ 'institution.details.communication' | transloco }}</span>
		</h3>

		<section class="communication" aria-labelledby="communication-heading">
			@if (preferredCommunicationWay()) {
				<p class="label communication-group-title">{{ 'institution.details.preferred_communication' | transloco }}</p>
				<p class="label">{{ getCommunicationTypeLabel(preferredCommunicationWay()!.categoryContactPointId) }}</p>
				@if (isPhoneType(preferredCommunicationWay()!.categoryContactPointId)) {
					<p>
						<a [href]="'tel:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else if (isEmailType(preferredCommunicationWay()!.categoryContactPointId)) {
					<p>
						<a [href]="'mailto:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else {
					<p>{{ preferredCommunicationWay()!.contactValue }}</p>
				}
				@if (
					shouldShowRemark(preferredCommunicationWay()!.remark, preferredCommunicationWay()!.categoryContactPointId)
				) {
					<p>{{ preferredCommunicationWay()!.remark }}</p>
				}
			}

			<!-- Additional communication ways -->
			@if (communicationWays().length >= 1) {
				<p style="padding-top: 10px" class="label communication-group-title">
					{{ 'institution.details.other_communication' | transloco }}
				</p>
				<section role="region">
					@for (cp of communicationWays(); track cp.id) {
						<div lvrBorder borderPosition="bottom" lvrPadding [padHorizontal]="8" [padVertical]="0">
							<p class="label">{{ getCommunicationTypeLabel(cp.categoryContactPointId) }}</p>
							@if (isPhoneType(cp.categoryContactPointId)) {
								<p>
									<a [href]="'tel:' + cp.contactValue">
										{{ cp.contactValue }}
									</a>
								</p>
							} @else if (isEmailType(cp.categoryContactPointId)) {
								<p>
									<a [href]="'mailto:' + cp.contactValue">
										{{ cp.contactValue }}
									</a>
								</p>
							} @else {
								<p>{{ cp.contactValue }}</p>
							}
							@if (shouldShowRemark(cp.remark, cp.categoryContactPointId)) {
								<p style="margin-top: 16px">{{ cp.remark }}</p>
							}
						</div>
					}
				</section>
			}
		</section>
	</section>
</section>
